import AbstractDashboardWidget from './abstractDashboardWidget';
import { ConstructorInput } from './dashboardWidgetFactory';

const ns = 'app.services.visualizationDashboardWidget';

export type Configurations = { visualizationId: string };

export default class VisualizationDashboardWidget extends AbstractDashboardWidget {
  #configurationsString: string;
  #configurations: Configurations | undefined;

  constructor(input: ConstructorInput) {
    super(input);
    this.#configurationsString = input.configurations;
  }

  getConfigurations(): Configurations {
    if (!this.#configurations) {
      const temp = JSON.parse(this.#configurationsString);
      if (typeof temp.visualizationId !== 'string') {
        throw new Error(`${ns}.getConfigurations: visualizationId is required in configurations`);
      }
      this.#configurations = temp as Configurations;
    }
    return this.#configurations;
  }
}
